<div
  class="flex items-center min-w-0"
  style="
    height: var(--selectionrow-height, 64px);
    gap: var(--selectionrow-gap, var(--spacing-sm));
    padding-left: var(--selectionrow-padding-left, var(--spacing-md));
    padding-right: var(--selectionrow-padding-right, var(--spacing-lg));
    padding-top: var(--selectionrow-padding-y, var(--spacing-md));
    padding-bottom: var(--selectionrow-padding-y, var(--spacing-md));
    border-radius: var(--selectionrow-border-radius, var(--radius-md));
    background: var(--selectionrow-background, var(--p-blue-100));
  "
>
  <div
    class="flex-1 flex items-center min-w-0"
    style="gap: var(--selectionrow-gap, var(--spacing-sm))"
  >
    @if (config().icon) {
      <div class="shrink-0">
        <app-dynamic
          componentName="SvgIcon"
          [props]="{
            name: config().icon,
            size: '24',
            color: 'var(--selectionrow-content, var(--p-surface-900))',
          }"
        />
      </div>
    }
    <div class="flex-1">
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: labelTextConfig() }"
      />
    </div>
  </div>
  @if (config().buttonText) {
    <button
      type="button"
      class="shrink-0 bg-transparent border-none cursor-pointer"
      [attr.aria-label]="config().buttonText"
      [attr.title]="config().buttonText"
      [disabled]="disabled()"
      (click)="onButtonClick()"
    >
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: buttonTextConfig() }"
      />
    </button>
  }
</div>
